const MarketingSurvey = () => import('./MarketingSurvey')
const SalesPlan = () => import('./SalesPlan')

export default function install(Vue) {
  Vue.component('modal-wrapper-marketing-survey', MarketingSurvey)
  Vue.component('modal-wrapper-sales-plan', SalesPlan)
}
